import n from "./index39.js";
import { resolveComponent as d, openBlock as s, createElementBlock as l, createElementVNode as e, createVNode as r, Transition as i, withCtx as h, createCommentVNode as p, pushScopeId as m, popScopeId as f } from "vue";
import "./index40.js";
import u from "../../../../_virtual/index.js";
const _ = (o) => (m("data-v-812a26ab"), o = o(), f(), o), g = { class: "search-modal" }, S = { class: "search-icon-container" }, v = {
  key: 0,
  class: "modal"
}, C = { class: "modal-header" }, M = /* @__PURE__ */ _(() => /* @__PURE__ */ e("h2", { class: "modal-header-title" }, "What are you looking for?", -1));
function b(o, a, k, I, $, w) {
  const c = d("ContractsSearch");
  return s(), l("div", g, [
    e("div", S, [
      e("button", {
        "aria-label": "Search",
        onClick: a[0] || (a[0] = (...t) => o.toggleModal && o.toggleModal(...t)),
        class: "search-icon"
      })
    ]),
    r(i, { name: "slide" }, {
      default: h(() => [
        o.showModal ? (s(), l("div", v, [
          e("div", C, [
            M,
            e("a", {
              onClick: a[1] || (a[1] = (...t) => o.toggleModal && o.toggleModal(...t)),
              class: "modal-close-button"
            })
          ]),
          r(c, {
            hasSearchIcon: !0,
            hasSearchButton: !1,
            placeholder: o.t("header.search-this-site"),
            config: o.config
          }, null, 8, ["placeholder", "config"])
        ])) : p("", !0)
      ]),
      _: 1
    })
  ]);
}
const E = /* @__PURE__ */ u(n, [["render", b], ["__scopeId", "data-v-812a26ab"]]);
export {
  E as default
};
//# sourceMappingURL=index35.js.map
